import renderCaptchaWidget from '@/yandex-captcha/renderCaptchaWidget';

/**
 * @module yandex-captcha/renderCaptchaWidgetOnVisible
 * @description
 * Работаем с Intersection Ovserver API.
 * Отслеживаем элемент с data-атрибутом в зоне видимости, и только тогда вызываем рендер капчи для конкретной формы.
 * @param {object} options - параметры для рендера капчи
 * @param {object} options.context - контекст
 * @param {DOMElement} options.captchaBlock - блок для рендера рекап
 * @param {object} options.renderParams - параметры рендера капчи
 *
 * @returns {void}
 */
export default ({ context, captchaBlock, renderParams, formType = '' }) => {
  const renderCaptchaCallback = (entries) => {
    window.EventBus.subscribe('yandex-captcha:insales:loaded', () => {
      try {
        if (entries[0].isIntersecting && entries[0].target.children.length === 0) {
          renderCaptchaWidget({
            container: captchaBlock,
            context,
            renderParams,
            formType
          });
        }
      } catch (catchErrorMessage) {
        if (window.smartCaptcha) {
          // В случае ошибки пробуем фоллбек
          window.yandexCaptchaCommon.initAndRenderCaptchaWidget({
            container: captchaBlock,
            context,
            renderParams,
            formType
          });

          return;
        }

        console.warn('Произошла ошибка при попытке рендера Yandex Captcha: ', {
          message: catchErrorMessage,
          container: captchaBlock,
          context,
          renderParams
        });
      }
    });
  };

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  const observer = new IntersectionObserver(renderCaptchaCallback, observerOptions);
  observer.observe(captchaBlock);
};
